module.exports = __webpack_public_path__ + "img/lizhiyu.a4446bcd.jpg";